import { render, staticRenderFns } from "./GreenAccomodationForm.vue?vue&type=template&id=0172504e&scoped=true&"
import script from "./GreenAccomodationForm.vue?vue&type=script&lang=js&"
export * from "./GreenAccomodationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0172504e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0172504e')) {
      api.createRecord('0172504e', component.options)
    } else {
      api.reload('0172504e', component.options)
    }
    module.hot.accept("./GreenAccomodationForm.vue?vue&type=template&id=0172504e&scoped=true&", function () {
      api.rerender('0172504e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/green/form/GreenAccomodationForm.vue"
export default component.exports